import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { desktopAssets } from 'src/containers/PreCache'

import styled from 'styled-components'
import ChatCard from '../components/Networking/ChatCard'
import MiniCountdown from '../components/Networking/MiniCountdown'
import config from '../config'
import { ChatDb } from '../firebaseConfig'
import { SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'
import useChat from '../utils/chatHelper'
import usePageAccess, { PageEnum } from 'src/utils/usePageAccess'
import { HiMiniArrowLeft } from 'react-icons/hi2'

const Page = styled.div`
  min-height: calc(100dvh - ${SIZES.navHeight});
  background-size: cover;
  background-image: url(${desktopAssets.landingBg});
  background-repeat: no-repeat;
  text-align: center;

  #content {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;

    @media (min-width: 1400px) {
      max-width: 1270px;
    }
  }
  
  .wrapper {
    display: flex;
    gap: 32px;
    
    @media (min-width: 1200px) {
      gap: 52px;
    }
  }

  .countdown-container {
    padding-top: 20px;
    flex-basis: 30%;
  }

  .chat-section {
    flex: 1;
    color: #fff;

    h6 {
      text-align: center;
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.25rem;
    }
  }

  .chat-container {
    
  }
`

export default function NetworkingLoungePage({ currentUser }) {
  usePageAccess({ currentUser, page: PageEnum.Networking, toastMsg: 'Networking Lounge is currently closed' })
  const { messages, messagesLoading, messagesError, handleSubmitMessage, submitLoading, handleFetchOlderMessages, fetchLoading, scrollTrigger } =
    useChat(ChatDb)
  const [users, setUsers] = useState([])

  useEffect(() => {
    document.title = `${config.eventName} | Networking`
  }, [])

  useEffect(() => {
    Amplitude.visit('Networking Lounge')
  }, [currentUser.id])

  const handleGoBack = () => {
    window.history.back()
  }

  useEffect(() => {
    Axios({
      url: `${config.apiUrl}/api/users`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    }).then((result) => {
      setUsers(result.data.users)
    })
  }, [])

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <Page>
      <div id="content" className='pt-5'>
        <header className="wrapper">
          <div className="countdown-container d-flex align-items-end">
            <div role="button" className="d-flex align-items-center text-white back-btn" onClick={handleGoBack}>
              <HiMiniArrowLeft />
              <span>Back</span>
            </div>
          </div>
          <div className="chat-section">
            <img src={desktopAssets.hallBanner} style={{ width: '100%', display: 'block' }} />
          </div>
        </header>
        <div className="wrapper">
          <div className="countdown-container">
            <MiniCountdown />
          </div>
          <div className="chat-section">
            {messagesError ? (
              <button id="refresh-btn" onClick={refreshPage}>
                Connection failed. Click here to refresh.
              </button>
            ) : (
              <div className="chat-container">
                <ChatCard
                  messages={messages}
                  messagesLoading={messagesLoading}
                  handleFetchOlderMessages={handleFetchOlderMessages}
                  fetchLoading={fetchLoading}
                  scrollTrigger={scrollTrigger}
                  handleSubmitMessage={handleSubmitMessage}
                  submitLoading={submitLoading}
                  currentUser={currentUser}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  )
}
